import {
  BASE_MNTN_URL,
  generateCacheBuster,
  getPageLocation,
  getReferrer,
  ORDER_VALUE
} from './mntnAnalytics.utils';

export const mntnAnalytics = {
  sendConversionTrackingRequest: (
    orderId: string,
    orderAmount: string,
    conversion_type: string,
    currency = '',
    productId = '',
    quantity = '',
    unitPrice = '',
    productImageLink = '',
    additional = ''
  ): void => {
    const referrer = getReferrer(512);
    const pageLocation = getPageLocation(512);
    const cacheBuster = generateCacheBuster();
    const url = `${BASE_MNTN_URL}conv=1&tdr=${referrer}&plh=${pageLocation}&cb=${cacheBuster}&shoid=${orderId}&shoamt=${orderAmount}&shocur=${currency}&shopid=${productId}&shoq=${quantity}&shoup=${unitPrice}&shpil=${productImageLink}${additional}&conversion_type=${conversion_type}`;

    const img = new Image();
    img.src = url;
  },

  fireConversion: (value: number, id: string, conversion_type: string): void => {
    mntnAnalytics.sendConversionTrackingRequest(id, value.toString(), conversion_type, 'USD');
  },

  trackNPVAppointmentBookingSucceeded: (appointmentId: string): void => {
    mntnAnalytics.fireConversion(ORDER_VALUE, appointmentId, 'NPV');
  },

  trackAccountSignUpComplete: (userId: string): void => {
    mntnAnalytics.fireConversion(ORDER_VALUE, userId, 'Account Sign Up Complete');
  },

  fireTrackingPixel: (): void => {
    const additional = '';
    const referrer = getReferrer(2048);
    const pageLocation = getPageLocation(2048);
    const cacheBuster = generateCacheBuster();

    const url = `${BASE_MNTN_URL}tdr=${referrer}&plh=${pageLocation}&cb=${cacheBuster}${additional}`;

    const img = new Image();
    img.src = url;
  }
};
